import { render, staticRenderFns } from "./font-style.vue?vue&type=template&id=9d5aac2c&"
import script from "./font-style.vue?vue&type=script&lang=js&"
export * from "./font-style.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports